// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3phh4","rootSuccess":"CompleteLink_rootSuccess__yOMbp","rootFailure":"CompleteLink_rootFailure__1NRES","isDisabled":"CompleteLink_isDisabled__3FriI"};